// Web stand-in for @invertase/react-native-apple-authentication.
//
// Aliased in place of the real package for the web bundle only (see
// webpack.config.web.js resolve.alias). Apple sign-in on web (login AND
// account-deletion reauth) is implemented for real via Firebase's
// OAuthProvider('apple.com') + signInWithPopup/reauthenticateWithPopup — see
// src/hooks/appleSignIn.web.ts (login) and ProfileScreen.tsx's
// reauthenticateForAccountDeletion (Platform.OS === 'web' branch, deletion
// reauth) — neither of those call sites ever touches this stub. This module
// only needs to exist so the top-level `import { appleAuth } from
// '@invertase/react-native-apple-authentication'` still used directly by
// ProfileScreen.tsx's NATIVE reauth branch resolves without crashing the web
// bundle; nothing on web actually calls performRequest() on it.
const NOT_SUPPORTED_MESSAGE =
  '[Tonyte][Web] The native Apple Sign-In SDK has no web build; this code path should be unreachable on web (see appleSignIn.web.ts / ProfileScreen.tsx web reauth branch).';

export const appleAuth = {
  isSupported: false,
  Operation: { LOGIN: 'LOGIN' },
  Scope: { EMAIL: 'EMAIL', FULL_NAME: 'FULL_NAME' },
  Error: { CANCELED: '1001' },
  async performRequest(): Promise<never> {
    throw new Error(NOT_SUPPORTED_MESSAGE);
  },
};

export default appleAuth;
